/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespSearchResultContainer_viewer$ref: FragmentReference;
export type SbRespSearchResultContainer_viewer = {|
  +isSeoQuicklookEnabled: ?boolean,
  +isTileAdEnabled: ?boolean,
  +isFavoritesEnabled: ?boolean,
  +isVisuallySimilarEnabled: ?boolean,
  +$refType: SbRespSearchResultContainer_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE",
    "type": "String!"
  }
];
return {
  "kind": "Fragment",
  "name": "SbRespSearchResultContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSeoQuicklookEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SEO_QUICKLOOK",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isTileAdEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isVisuallySimilarEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "VISUALLY_SIMILAR",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ede9d709270d724ee2a1a6489be15270';
module.exports = node;
